import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[appFilterSelectItem]',
    standalone: false,
})
export class FilterSelectItemTemplateDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({
    selector: '[appFilterSelectSelectedItem]',
    standalone: false,
})
export class FilterSelectSelectedItemTemplateDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({
    selector: '[appFilterSelectFilter]',
    standalone: false,
})
export class FilterSelectFilterTemplateDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({
    selector: '[appFilterSelectFooter]',
    standalone: false,
})
export class FilterSelectFooterTemplateDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}

